/** Drive pt-view-definition catalog from attention-manifest drive-operational-flow meta. */

export type DriveViewCatalogEntry = {
  viewKey: string;
  viewId?: string;
  label: string;
  roleLens?: string;
  period?: string;
  spineAxis?: string;
  level?: string;
};

export const DRIVE_VIEW_DEFAULT_KEY = '';

export function parseDriveViewCatalog(manifest: unknown): {
  catalog: DriveViewCatalogEntry[];
  selectedViewKey: string;
} {
  const empty = { catalog: [] as DriveViewCatalogEntry[], selectedViewKey: DRIVE_VIEW_DEFAULT_KEY };
  if (!manifest || typeof manifest !== 'object') return empty;
  const sections = (manifest as { sections?: unknown }).sections;
  if (!Array.isArray(sections)) return empty;
  const drive = sections.find(
    (s) => s && typeof s === 'object' && (s as { id?: string }).id === 'drive-operational-flow'
  ) as { meta?: Record<string, unknown> } | undefined;
  const meta = drive?.meta;
  if (!meta || typeof meta !== 'object') return empty;
  const raw = meta.viewCatalog;
  const catalog: DriveViewCatalogEntry[] = [];
  if (Array.isArray(raw)) {
    for (const row of raw) {
      if (!row || typeof row !== 'object') continue;
      const r = row as Record<string, unknown>;
      const viewKey = String(r.viewKey || r.view_key || '').trim();
      if (!viewKey) continue;
      catalog.push({
        viewKey,
        viewId: r.viewId ? String(r.viewId) : r.view_id ? String(r.view_id) : undefined,
        label: String(r.label || viewKey),
        roleLens: r.roleLens ? String(r.roleLens) : undefined,
        period: r.period ? String(r.period) : undefined,
        spineAxis: r.spineAxis ? String(r.spineAxis) : undefined,
        level: r.level ? String(r.level) : undefined,
      });
    }
  }
  const selected = String(meta.selectedViewKey || meta.selected_view_key || '').trim();
  return { catalog, selectedViewKey: selected };
}
